import { Component, HostBinding, Inject, Input } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { WINDOW } from '@core/tools/window';
import { DocumentationService } from '../documentation/documentation.service';


@Component({
    selector: 'contextual-help',
    templateUrl: './contextual-help.component.html',
    styleUrls: ['./contextual-help.component.scss'],
    standalone: false
})
export class ContextualHelpComponent {
  @Input() color: ThemePalette = 'primary';
  @HostBinding() class = 'contextual-help';

  constructor(
    private docService: DocumentationService,
    @Inject(WINDOW) public window: Window
  ) {}

  openDocumentation(): string {
    const url = this.docService.getDocumentationUrl();
    this.window.open(url, '_BLANK');
    return url;
  }
}
